// import Vue from 'vue'
// import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

// Vue.use(Router)

// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'HelloWorld',
//       component: HelloWorld
//     }
//   ]
// })

import Vue from 'vue'
import Router from 'vue-router'
const Index = () => import('./../page/index.vue')
// const Login = () => import('/page/Login/login.vue')
// const Register = () => import('/page/Login/register.vue')
const Home = () => import('./../page/Home/home.vue')
const user = () => import('./../page/User/user.vue')
const myChair = () => import('./../page/User/children/myChair.vue')
const information = () => import('./../page/User/children/information.vue')
const myComments = () => import('./../page/User/children/myComments.vue')
const myCollection = () => import('./../page/User/children/myCollection.vue')
const reservation = () => import('./../page/User/children/reservation.vue')
const lecturer = () => import('./../page/User/children/lecturer.vue')
const orderDetail = () => import('./../page/User/children/orderDetail.vue')
const News = () => import('./../page/News/news.vue')
const NewsList = () => import('./../page/News/newsList.vue')
const NewsDetail = () => import('./../page/News/newsDetail.vue')
const Chair = () => import('./../page/Chair/Chair.vue')
const ChairIndex = () => import('./../page/Chair/children/index.vue')
const ChairSearch = () => import('./../page/Chair/children/search.vue')
const ChairList = () => import('./../page/Chair/children/list.vue')
const lectureDetail = () => import('./../page/Chair/children/lectureDetail.vue')
const publish = () => import('./../page/Chair/children/publish.vue')
const detail = () => import('./../page/Chair/children/detail.vue')
const Product = () => import('./../page/Product/product.vue')
const ProductList = () => import('./../page/Product/productStore.vue')
const ProductDetail = () => import('./../page/Product/productDetail.vue')
const About = () => import('./../page/About/about.vue')
const Me = () => import('./../page/About/me.vue')
const Industry = () => import('./../page/Industry/Industry.vue')
const IndustryList = () => import('./../page/Industry/list.vue')
const IndustryDetail = () => import('./../page/Industry/detail.vue')
const NewProduct = () => import('./../page/NewProduct/newProduct.vue')
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      name: 'index',
      redirect: '/home',
      children: [
        {path: 'home', component: Home},
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      redirect: '/user/information',
      children: [
        {path: 'myChair', name: 'MyChair', component: myChair},
        {path: 'orderDetail', name: '订单详情', component: orderDetail},
        {path: 'information', name: 'Information', component: information},
        {path: 'myComments', name: 'MyComments', component: myComments},
        {path: 'myCollection', name: 'MyCollection', component: myCollection},
        {path: 'lecturer', name: 'Lecturer', component: lecturer},
        {path: 'reservation', name: 'Reservation', component: reservation}
      ]
    },
    {
      path: '/product',
      name: 'product',
      component: Product,
      redirect: '/product/productList',
      children: [
        {path: 'productList', name: 'ProductList', component: ProductList},
        {path: 'productDetail', name: 'ProductDetail', component: ProductDetail}
      ]
    },
    {
      path: '/newproduct',
      name: 'newproduct',
      component: NewProduct,
      redirect: '/newproduct/newproduct',
      children: [
        {path: 'newProduct', name: 'NewProduct', component: NewProduct},
      ]
    },
    {
      path: '/news',
      name: 'news',
      component: News,
      redirect: '/news/newsList',
      children: [
        {path: 'newsList', name: 'newsList', component: NewsList},
        {path: 'newsDetail', name: 'NewsDetail', component: NewsDetail}
      ]
    },
    {
      path: '/chair',
      name: 'chair',
      component: Chair,
      redirect: '/chair/ChairIndex',
      children: [
        {path:'ChairIndex',name:'讲座',component: ChairIndex},
        {path:'ChairSearch',name:'ChairSearch',component: ChairSearch},
        {path:'ChairList',name:'ChairList',component: ChairList},
        {path:'lectureDetail',name:'讲师详情',component: lectureDetail},
        {path:'publish',name:'publish',component: publish},
        {path:'detail',name:'Detail',component: detail}
      ]
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      redirect: '/about/me',
      children: [
        {path: 'me', name: 'me', component: Me},
      ]
    },
    {
      path: '/industry',
      name: 'Industry',
      component: Industry,
      redirect: '/industry/list',
      children: [
        {path: 'list', name: 'IndustryList', component: IndustryList},
        {path: 'detail', name: 'IndustryDetail', component: IndustryDetail},
      ]
    },
    {path: '*', redirect: '/home'}
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js